<template>
  <scoped>
    <VerticalNavigator
      :links="[{
        title: 'Create',
        routeName: 'create_customer'
      }]"
    >
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Customers"
      />
      <h1>
        Customers
      </h1>
      <div class="grid">
        <div class="list">
          <CustomerSelector v-model:value="selectedCustomer" />
        </div>
        <div
          v-if="selectedCustomer"
          class="summary"
        >
          <CustomerSummary
            :key="selectedCustomer.id"
            :customerID="selectedCustomer.id"
          />
          <Button
            title="Edit"
            :image="require('@/images/edit_icon.png')"
            @click="customerRedirect()"
          />
        </div>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import CustomerSelector from "@/components/selectors/customer.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import CustomerSummary from "@/components/summaries/customer.vue"
  import router from "@/router"
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"

  const selectedCustomer = ref<Customer>(null)

  function customerRedirect() {
    router.push({
      name: "edit_customer",
      params: {
        customerID: selectedCustomer.value.id
      }
    })
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-areas: "list summary";
    grid-template-columns: auto 1fr;

    .list {
      grid-area: list;
      margin: 0 1em 1em 0;
    }

    .summary {
      grid-area: summary;
    }
  }
</style>
